import { Progress, Spin } from "antd";
import { ViewerModal } from "Components/ViewerModal";
import { observer } from "mobx-react";
import { ApryseViewer } from "./ApryseViewer";
import { apryseViewerStore } from "Stores/PdfViewerStore/ApryseViewerStore";

export const ApryseViewerModal = observer(() => {
  return (
    <ViewerModal
      title={apryseViewerStore.fileName}
      visible={apryseViewerStore.isVisible}
      onCancel={apryseViewerStore.closeModal}
      escToClose={false}
      styles={{
        body: {
          height: "100%",
          overflow: "hidden",
          position: "relative",
        },
      }}
    >
      <Spin spinning={apryseViewerStore.isClosing} fullscreen />
      {apryseViewerStore.state === "LOADING" ? (
        <div className="text-center">
          <Progress style={{ maxWidth: 500, width: `50%` }} percent={apryseViewerStore.progress} status="active" />
        </div>
      ) : (
        <ApryseViewer />
      )}
    </ViewerModal>
  );
});
